import React from 'react'
import img1 from '../../../assets/images/modern01.png'
import img2 from '../../../assets/images/secure_data.png'
import img3 from '../../../assets/images/modern02.png'
import img4 from '../../../assets/images/modern03.png'

const Main = ({gredient}) => {
  return (
    <>
        <section className={`row_am modern_ui_section ${gredient && "gredient-bg"}`} >
            {gredient &&
            <div className="modernui_section_bg modernui-gredient"> <img src="/assets/images/section-bg.png" alt="image"/> </div>}
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="ui_text">
                        <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                            <h2>Beautiful design with <span>modern UI</span></h2>
                            <p>
                            Every 2 years we re-develop Accord in the latest technology so you're always ahead of the competition.
                            </p>
                        </div>
                        <ul className="design_block">
                            <li  data-aos-duration="1500">
                            <h4>Carefully designed</h4>
                            <p>We work directly with our clients to constantly improve and provide the best user experience possible..</p>
                            </li>
                            <li  data-aos-duration="1500">
                            <h4>Seamless Sync</h4>
                            <p>Use Accord across all of your devices; mobile, tablet, and desktop with our seamless sync technology.</p>
                            </li>
                            <li  data-aos-duration="1500">
                            <h4>Anytime, Anywhere</h4>
                            <p>Accord utilizes cloud technology to provide a seamless experience anywhere in the world.</p>
                            </li>
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="ui_images"  data-aos-duration="1500">
                        <div className="left_img">
                            <img className="moving_position_animatin" src={img1} alt="image" />
                        </div>
                        <div className="right_img">
                            <img className="moving_position_animatin" src={img2} alt="image" />
                            <img className="moving_position_animatin" src={img3} alt="image" />
                            <img className="moving_position_animatin" src={img4} alt="image" />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main